/**
 * KATSHU · 5 sept 2026 — EL REGALO SE CUENTA, NO SE AÑADE.
 *
 * QUÉ SUSTITUYE: a `gift-with-purchase.js`, que metía un pack de filtros a
 * 0,00 € como ARTÍCULO SEPARADO en el carrito. Eso arrastraba tres problemas
 * verificados, ninguno teórico:
 *   1. Cada pedido llegaba a HyperSKU con una línea fantasma a $0,00 sin
 *      mapear. Había que cancelarla allí y cerrarla A MANO en Shopify con el
 *      aviso al cliente desactivado; si no, la clienta veía su pedido como
 *      «preparado parcialmente» PARA SIEMPRE (el fallo de Karin, fabricado).
 *   2. El inventario de «Filtros de Repuesto» iba en -4 y bajando.
 *   3. Con dos implementaciones a la vez llegó a añadir DOS packs: dos clientas
 *      abandonaron el pago el 29 ago con 95,80 € en vez de 79,90 €.
 *
 * QUÉ HACE AHORA: añade una PROPIEDAD DE LÍNEA a la fuente. El regalo se sigue
 * viendo en el carrito, en el checkout, en el correo de confirmación y en el
 * pedido de Shopify — pero no es un artículo: no toca inventario, no viaja a
 * HyperSKU como línea y no deja pedidos a medias.
 *
 * LO QUE SE PIERDE, A SABIENDAS: la línea de descuento de -15,90 € en el
 * checkout. Decisión de David, 5 sept 2026. El argumento sigue en la caja de
 * compra de la ficha, que es la pantalla donde se decide.
 *
 * NO PUEDE ROMPER LA COMPRA: solo añade un <input type="hidden">. Va entero
 * dentro de un try/catch y, si algo falla, el formulario queda exactamente
 * como estaba.
 *
 * REVERTIR: quitar el <script> de snippets/scripts.liquid, volver a activar el
 * de gift-with-purchase.js y reactivar el descuento automático «6 meses de
 * recambios incluidos» en Shopify › Descuentos.
 */

// KATSHU™ Water Ritual™ — Pocket y Signature, los dos llevan el regalo.
// 28 sept 2026: antes solo el Pocket (12056188322056) lo llevaba; la
// Signature (12298735583496) no mostraba esta nota nunca en carrito/checkout.
const TRIGGER_PRODUCT_IDS = ['12056188322056', '12298735583496'];

const PROPERTY_NAME = 'Incluye';
// 7 oct 2026 · FILTER REPLACEMENT MASTER: la formulación canónica es
// «recambios para seis meses incluidos». Con la etiqueta «Incluye» delante, el
// valor se adapta a «recambios para seis meses» — sintaxis, no contenido.
// ⛔ PROHIBIDO en esta cadena: «regalo», el valor económico (antes decía
// «· valor 15,90 €») y el número de filtros. Esta propiedad se graba en el
// carrito, el checkout, el correo de confirmación y el PEDIDO: es permanente.
// Fuente de verdad: context/PRODUCTO.md §FILTER REPLACEMENT MASTER.
const PROPERTY_VALUE = 'recambios para seis meses';
const MARKER = 'data-katshu-gift-note';

/**
 * Mete la propiedad en todos los formularios de añadir al carrito de la fuente
 * que haya en la página (la ficha tiene el principal y el de la barra fija).
 */
function marcarFormularios() {
  try {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach((form) => {
      if (form.hasAttribute(MARKER)) return;

      // Solo la fuente, y SOLO si lo podemos demostrar. Si no encontramos el
      // id del producto, NO se marca: más vale un regalo sin texto que poner
      // «incluye 6 meses de recambios» en el pack de filtros suelto.
      const contenedor = form.closest('[data-product-id]');
      const productId = contenedor?.dataset.productId || form.dataset.productId;
      if (!TRIGGER_PRODUCT_IDS.includes(String(productId ?? ''))) return;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${PROPERTY_NAME}]`;
      input.value = PROPERTY_VALUE;
      form.appendChild(input);
      form.setAttribute(MARKER, 'true');
    });
  } catch (error) {
    // El regalo es un texto; la compra es el negocio. Si esto falla, se calla.
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', marcarFormularios);
} else {
  marcarFormularios();
}

// La ficha reinyecta secciones (cambio de variante, barra fija): se repasa.
document.addEventListener('shopify:section:load', marcarFormularios);
